export default {
  path: '/managementStatistics',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'assetsRentalList',
      name: 'assetsRentalList',
      component: () => import('@/pages/managementStatistics/assetsRental/list.vue'),
      meta: {
        keepAlive: true,
        title: '经营统计管理',
      },
    },
    {
      path: 'leasingAssetsTuationImport',
      name: 'leasingAssetsTuationImport',
      component: () =>
        import('@/pages/managementStatistics/assetsRental/leasingAssetsImport/index.vue'),
      meta: {
        keepAlive: true,
        title: '导入资产出租情况表',
      },
    },
    {
      path: 'productionInformationNumberImport',
      name: 'productionInformationNumberImport',
      component: () =>
        import('@/pages/managementStatistics/assetsRental/productionInformationNumber/index.vue'),
      meta: {
        keepAlive: true,
        title: '导入生产资料商品购、销、存数量',
      },
    },
    {
      path: 'productionInformationTotalAmountImport',
      name: 'productionInformationTotalAmountImport',
      component: () =>
        import(
          '@/pages/managementStatistics/assetsRental/productionInformationTotalAmount/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '导入生产资料商品购、销、存总额(含税)',
      },
    },
    {
      path: 'profitStatementImport',
      name: 'profitStatementImport',
      component: () =>
        import('@/pages/managementStatistics/assetsRental/profitStatement/index.vue'),
      meta: {
        keepAlive: true,
        title: '导入盈利报表',
      },
    },
    {
      path: 'transitMaterialsStatisticsImport',
      name: 'transitMaterialsStatisticsImport',
      component: () =>
        import('@/pages/managementStatistics/assetsRental/transitMaterialsStatistics/index.vue'),
      meta: {
        keepAlive: true,
        title: '导入主要中转物资统计表',
      },
    },
    // 审批页跳转
    {
      path: 'detail',
      name: 'JGB-managementStatistics',
      component: () => import('@/pages/managementStati/detail/index.vue'),
      meta: {
        keepAlive: true,
        title: '经管部统计审批',
      },
    },
    // 生产出租
    {
      path: 'leasingAssetsImport',
      name: 'JGB-leasingAssetsImport',
      component: () => import('@/pages/managementStati/leasingAssetsImport/index.vue'),
      meta: {
        keepAlive: true,
        title: '经管部统计审批',
      },
    },
    // 生产资料
    {
      path: 'productionInformationNumber',
      name: 'JGB-productionInformationNumber',
      component: () => import('@/pages/managementStati/productionInformationNumber/index.vue'),
      meta: {
        keepAlive: true,
        title: '经管部统计审批',
      },
    },
    // 生产资料含税
    {
      path: 'productionInformationTotalAmount',
      name: 'JGB-productionInformationTotalAmount',
      component: () => import('@/pages/managementStati/productionInformationTotalAmount/index.vue'),
      meta: {
        keepAlive: true,
        title: '经管部统计审批',
      },
    },
    // 利润表
    {
      path: 'profitStatement',
      name: 'JGB-profitStatement',
      component: () => import('@/pages/managementStati/profitStatement/index.vue'),
      meta: {
        keepAlive: true,
        title: '经管部统计审批',
      },
    },
    // 中转物资
    {
      path: 'transitMaterialsStatistics',
      name: 'JGB-transitMaterialsStatistics',
      component: () => import('@/pages/managementStati/transitMaterialsStatistics/index.vue'),
      meta: {
        keepAlive: true,
        title: '经管部统计审批',
      },
    },
  ],
};
